import {useAppSelector} from '@/hooks';
import {formatExpiryDate} from './ai-chat-credits-dropdown.library';

export const useCreditsExpiryLines = (): string[] => {
  const freeCredits = useAppSelector((s) => s.teamCredits.freeCredits);
  const freeCreditsExpiryDate = useAppSelector((s) => s.teamCredits.freeCreditsExpiryDate);
  const legacyCredits = useAppSelector((s) => s.teamCredits.legacyCredits);
  const legacyCreditsExpiryDate = useAppSelector((s) => s.teamCredits.legacyCreditsExpiryDate);
  const purchasedCredits = useAppSelector((s) => s.teamCredits.purchasedCredits);
  const lines: string[] = [];

  if (freeCredits > 0 && freeCreditsExpiryDate) {
    const formattedDate = formatExpiryDate(freeCreditsExpiryDate);

    if (formattedDate) {
      lines.push(window.i18next.t('pmwjs_x_plan_credits_expire_on_date', {numCredits: freeCredits.toLocaleString(), date: formattedDate}));
    }
  }

  if (legacyCredits > 0 && legacyCreditsExpiryDate) {
    const formattedDate = formatExpiryDate(legacyCreditsExpiryDate);

    if (formattedDate) {
      lines.push(window.i18next.t('pmwjs_x_legacy_credits_expire_on_date', {numCredits: legacyCredits.toLocaleString(), date: formattedDate}));
    }
  }

  if (purchasedCredits > 0) {
    lines.push(window.i18next.t('pmwjs_x_purchased_credits_never_expire', {numCredits: purchasedCredits.toLocaleString()}));
  }

  return lines;
};
